
import { replaceItem } from './array';

export const updateItemByPropertyName = (array, id, updater, propName = 'id') => {
  const item = array.find(el => el[propName] === id);

  if (!item) {
    console.warn(`Item with id ${id} wasn't found.`);
    return array;
  }

  const replaceAt = array.indexOf(item);

  return replaceItem(array, { ...item, ...updater }, replaceAt);
};
